// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__1NKAL","dragIcon":"Choice_dragIcon__2OCrd","left":"Choice_left__2vf6z","input":"Choice_input__2dkDD"};